import api from './api';
import { Tool, ToolCategory, ToolPermission, ToolStatus, CategoryCount, TagCount, ToolExecuteResult, TestScenario } from '../types/tool';

export async function listTools(
  category?: ToolCategory,
  permission?: ToolPermission,
  tags?: string[],
  status?: ToolStatus,
  minVersion?: string
): Promise<Tool[]> {
  const params = new URLSearchParams();
  if (category) params.append('category', category);
  if (permission) params.append('permission', permission);
  if (tags && tags.length) params.append('tags', tags.join(','));
  if (status) params.append('status', status);
  if (minVersion) params.append('min_version', minVersion);

  const response = await api.get('/tools/', { params });
  return response.data;
}

export async function getToolDetails(toolName: string): Promise<Tool> {
  const response = await api.get(`/tools/${toolName}/`);
  return response.data;
}

export async function getToolCategories(): Promise<CategoryCount[]> {
  try {
    const response = await api.get('/tools/categories/');
    return response.data;
  } catch (error) {
    console.error('Error fetching tool categories:', error);
    return [];
  }
}

export async function getToolTags(): Promise<TagCount[]> {
  try {
    const response = await api.get('/tools/tags/');
    return response.data;
  } catch (error) {
    console.error('Error fetching tool tags:', error);
    return [];
  }
}

export async function getToolStatusCounts(): Promise<{status: string, count: number}[]> {
  try {
    const response = await api.get('/tools/status/');
    return response.data;
  } catch (error) {
    console.error('Error fetching tool status counts:', error);
    return [];
  }
}

// Function to get all tools (simplified for workflow canvas)
export async function getTools() {
  try {
    const response = await api.get('/tools/');
    return response.data;
  } catch (error) {
    console.error('Error fetching tools:', error);
    throw error;
  }
}

export async function getTool(toolId: string) {
  try {
    return await getToolDetails(toolId);
  } catch (error) {
    console.error(`Error fetching tool ${toolId}:`, error);
    throw error;
  }
}

export async function executeTool(toolName: string, parameters: Record<string, any>): Promise<ToolExecuteResult> {
  const response = await api.post(`/tools/${toolName}/execute`, { parameters });
  return response.data;
}

export async function getTestScenarios(toolName: string): Promise<TestScenario[]> {
  const response = await api.get(`/tools/${toolName}/test-scenarios`);
  return response.data;
}
